import { axios } from './config';

export const getFramerateNetworkDocConfig = () => {
	return axios.get('/prebid/framerate-network-config');
};
